import { Getters } from 'vuex-smart-module';
import MaterialsState from './state';

export default class MaterialsGetters extends Getters<MaterialsState> {}
